<template>
  <div class="content voucher-list">
    <div class="form-content">
      <div style="margin-bottom: 1%">
        <div style="display: flex; align-items: center">
          <a-button type="primary" @click="createHandle">
            <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
            {{ $t('新增凭证') }}
          </a-button>
          <a-button type="primary" @click="openImportModal">
            <a-icon type="upload" />
            {{ $t('批量导入') }}
          </a-button>
        </div>
      </div>
      <a-row :gutter="16">
        <a-col :span="6">
          <a-input allow-clear v-model.trim="formData.voucherSn" :placeholder="$t('凭证单据号')" />
        </a-col>
        <a-col :span="6">
          <a-input allow-clear v-model.trim="formData.voucherNo" :placeholder="$t('凭证号')" />
        </a-col>
        <a-col :span="6">
          <CommonSelect
            :list="journal_voucher_type"
            :code.sync="formData.voucherType"
            :placeholder="$t('凭证字')"
          />
        </a-col>
        <a-col :span="6">
          <DateRangePicker
            id="effectiveTime"
            :needhms="false"
            @get_date="chooseAccountingDate"
            :placeholder="$t(`记账日期`)"
            :start-time="formData.accountingDateStart"
            :end-time="formData.accountingDateEnd"
          />
        </a-col>
      </a-row>
      <a-row :gutter="16" style="margin-top: 10px">
        <a-col :span="6">
          <DateRangePicker
            id="effectiveTime"
            :needhms="false"
            @get_date="chooseBizTime"
            :placeholder="$t(`业务日期`)"
            :start-time="formData.bizTimeStart"
            :end-time="formData.bizTimeEnd"
          />
        </a-col>
        <a-col :span="6">
          <CommonQuerySelect
            api="queryAccountingCalendarDetailPage"
            valueName="accounting_period_code"
            labelName="accounting_period_name"
            :code.sync="formData.accountingPeriod"
            :placeholder="$t(`会计期间`)"
          />
        </a-col>
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.sourceDocSn"
            :placeholder="$t('来源单据单号')"
          />
        </a-col>
        <a-col :span="6">
          <CommonSelect
            :list="document_type"
            :code.sync="formData.sourceDocType"
            :placeholder="$t('来源单据类型')"
          />
        </a-col>
      </a-row>
      <a-row :gutter="16" style="margin-top: 10px">
        <a-col :span="6">
          <CommonSelect
            :isBu="true"
            :list="$store.state.settlementBuList"
            :placeholder="$t('结算组织')"
            :code.sync="formData.businessUnitCode"
            :name.sync="formData.businessUnitName"
            @change="queryList(1)"
          />
        </a-col>
        <a-col :span="18">
          <a-button @click="queryList(1)" type="primary">
            <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
            {{ $t(`查询`) }}
          </a-button>
          <a-button @click="reset">
            <a-icon type="redo" />
            {{ $t(`重置`) }}
          </a-button>
          <a-button type="primary" ghost @click="openReportPreview">
            <a-icon type="file-search" />
            {{ $t('报表预览') }}
          </a-button>
        </a-col>
      </a-row>
    </div>
    <div class="table-content">
      <div class="table-header">
        <div class="row status-list-wrap">
          <a-tabs default-active-key="" @change="setSearchStatus">
            <a-tab-pane key="">
              <template slot="tab">
                <span>{{ $t('全部') }}</span>
              </template>
            </a-tab-pane>
            <a-tab-pane v-for="item in journal_voucher_status" :key="item.code">
              <template slot="tab">
                <span>{{ $t(item.name) }}</span>
              </template>
            </a-tab-pane>
          </a-tabs>
        </div>
        <div class="btns flex-ct gap10">
          <OperateBtn
            api="voucherAction"
            :text="$t('审核')"
            :params="{
              actionType: 'CHECK',
              idList: selectedRowKeys,
            }"
            :disabled="selectedRowKeys.length === 0"
            @success="queryList"
          />
          <OperateBtn
            api="voucherAction"
            :text="$t('驳回')"
            :params="{
              actionType: 'REJECT',
              idList: selectedRowKeys,
            }"
            :disabled="selectedRowKeys.length === 0"
            @success="queryList"
          />
          <OperateBtn
            api="voucherAction"
            :text="$t('冲销')"
            :params="{
              actionType: 'CANCEL',
              idList: selectedRowKeys,
            }"
            :disabled="selectedRowKeys.length === 0"
            @success="queryList"
          />
          <TableSetting :columns="columns" @change="changeColumns" />
        </div>
      </div>
      <!-- expandedRowRender 展开有问题 不能用CommonTable -->
      <div class="table-body">
        <a-table
          size="small"
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
          :columns="showColumns"
          :loading="loading"
          :dataSource="tableData"
          :pagination="false"
          rowKey="id"
          :scroll="{ x: 'max-content' }"
        >
          <template slot="no" slot-scope="text, record, index">
            <span>{{ index + 1 }}</span>
          </template>
          <template slot="voucherSn" slot-scope="text, record">
            <span class="text-link" @click="viewDetail(record)">{{ record.voucher_sn }}</span>
          </template>
          <template slot="source_doc_sn" slot-scope="text, record">
            <template v-if="record.source_doc_sn?.length">
              <div
                class="text-link"
                v-for="(item, index) in record.source_doc_sn.split(',')"
                :key="item"
                @click="viewSourceDetail(record, index)"
              >
                {{ item }}
              </div>
            </template>
          </template>

          <template slot="expandedRowRender" slot-scope="record">
            <CommonTable
              style="background: #fff"
              :dataSource="record.detail_list"
              :columns="detailColumns"
              :showPagination="false"
              :showSetting="false"
              rowKey="id"
            ></CommonTable>
          </template>
        </a-table>
      </div>
      <div class="table-footer mt10">
        <pagination
          :pageNo="pageNo"
          :length="pageSize"
          :total-count="total"
          @paginate="paginate"
        ></pagination>
      </div>
    </div>

    <a-modal
      v-model="importVisible"
      :title="$t('批量导入') + '凭证'"
      :width="500"
      :footer="null"
      @cancel="handleImportCancel"
    >
      <div class="upload-content">
        <a-upload-dragger
          name="file"
          :fileList="fileList"
          action=""
          :multiple="false"
          :customRequest="handleChange"
          @change="handleUploadChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="upload" />
          </p>
          <p class="ant-upload-hint">{{ $t('点击选择或者拖拽要上传的文件') }}</p>
        </a-upload-dragger>

        <a v-if="xlsDownloadUrl" target="_blank" class="text-info mt10" :href="xlsDownloadUrl">
          {{ $t('批量导入') }}凭证导入模板.xlsx
        </a>
      </div>
    </a-modal>

    <a-modal
      v-model="reportPreviewVisible"
      :title="$t('报表预览')"
      :width="960"
      :footer="null"
      @cancel="handleReportPreviewCancel"
    >
      <a-row :gutter="16">
        <a-col :span="12">
          <CommonQuerySelect
            ref="reportTemplateSelect"
            api="getFinancialStatementTemplateList"
            :params="{
              businessUnitCode: formData.businessUnitCode,
              page_no: 1,
              page_size: 100,
            }"
            init
            :code.sync="previewForm.templateCode"
            :name.sync="previewForm.templateName"
            :placeholder="$t('报表模板')"
            @change="changeReportTemplate"
          />
        </a-col>
        <a-col :span="12">
          <AccountingPeriodRange
            ref="accountingPeriodRange"
            :businessUnitCode="formData.businessUnitCode"
            @change="previewForm.accountingPeriodList = $event"
          />
        </a-col>
      </a-row>
      <div style="margin-top: 15px; text-align: right">
        <a-button @click="reportPreviewVisible = false">
          {{ $t('取消') }}
        </a-button>
        <a-button
          type="primary"
          :loading="previewLoading"
          style="margin-left: 10px"
          @click="previewReport"
        >
          <a-icon type="search" />
          {{ $t('预览') }}
        </a-button>
      </div>
      <CommonTable
        v-show="showPreviewTable"
        class="no-padding-table"
        :columns.sync="previewColumns"
        :loading="previewLoading"
        :dataSource="previewTableData"
        :showSetting="false"
        :showPagination="false"
        :showNo="false"
        :tableProps="{ bordered: true }"
        style="margin-top: 15px"
      >
        <template v-slot:content="{ text, record }">
          <div :class="'pl' + (record.level - 1) * 20">{{ text }}</div>
        </template>
        <template v-slot:currentPeriodAmount="{ record }">
          <PriceInput
            :showTxt="true"
            :showZeroPrice="true"
            :value.sync="record.currentPeriodAmount"
            :propsStyle="previewAmountStyle"
            :precision="2"
          />
        </template>
        <template v-slot:currentYearAmount="{ record }">
          <PriceInput
            :showTxt="true"
            :showZeroPrice="true"
            :value.sync="record.currentYearAmount"
            :propsStyle="previewAmountStyle"
            :precision="2"
          />
        </template>
        <template v-slot:lastPeriodAmount="{ record }">
          <PriceInput
            :showTxt="true"
            :showZeroPrice="true"
            :value.sync="record.lastPeriodAmount"
            :propsStyle="previewAmountStyle"
            :precision="2"
          />
        </template>
      </CommonTable>
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import { add } from '@/common/number'
import DateRangePicker from '@component/dateRangePicker'
import pagination from '@/component/pagination.vue'
import TableSetting from '@/component/tableSetting.vue'
import AccountingPeriodRange from '@/component/accountingPeriodRange'
import { jumpSoucePage, convertKeysToCamelCase } from '@/common'
import { getCookie } from '@/common/cookie'
export default {
  name: 'VoucherList',
  components: { pagination, DateRangePicker, TableSetting, AccountingPeriodRange },
  data() {
    return {
      formData: {
        businessUnitCode: undefined,
        businessUnitName: undefined,
      },
      importVisible: false,
      importLoading: false,
      fileList: [],
      xlsDownloadUrl:
        'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/fms/%E5%87%AD%E8%AF%81%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx',
      tableData: [],
      selectedRowKeys: [],
      selectedRows: [],
      loading: false,
      total: 0,
      pageNo: 1,
      pageSize: 20,

      columns: [],

      reportPreviewVisible: false,
      previewLoading: false,
      showPreviewTable: false,
      previewTableData: [],
      previewForm: {
        templateCode: undefined,
        templateName: undefined,
        templateType: undefined,
        accountingPeriodList: [],
      },
    }
  },
  mounted() {
    this.setColumns()
  },
  activated() {
    this.queryList()
  },
  computed: {
    ...mapState(['journal_voucher_type', 'journal_voucher_status', 'document_type']),
    ...mapGetters([
      'currencyListMapping',
      'documentTypeMapping',
      'journalVoucherTypeMapping',
      'journalVoucherStatusMapping',
    ]),
    showColumns() {
      return [
        {
          title: '#',
          align: 'center',
          key: 'NO',
          width: 60,
          scopedSlots: {
            customRender: 'no',
          },
        },
        ...this.columns,
      ]
    },
    detailColumns() {
      return [
        { title: this.$t('科目编码'), dataIndex: 'account_code' },
        { title: this.$t('科目名称'), dataIndex: 'account_name' },
        {
          title: this.$t('核算维度'),
          dataIndex: 'dimension_list',
          customRender: (text) =>
            text
              ?.map(
                (item) =>
                  `${item.accounting_dimension_name}:${item.accounting_dimension_value_name}`
              )
              .join(', '),
        },
        {
          title: this.$t('币别'),
          dataIndex: 'currency',
          customRender: (text) => this.currencyListMapping[text],
        },
        {
          title: this.$t('借方金额'),
          dataIndex: 'debit_amount',
          customRender: (text, record) => this.showPrice(text, record.currency),
        },
        {
          title: this.$t('贷方金额'),
          dataIndex: 'credit_amount',
          customRender: (text, record) => this.showPrice(text, record.currency),
        },
        {
          title: this.$t('现金流量'),
          dataIndex: 'cash_flow_allocation_list',
          customRender: (text, record) => {
            const list = text || record.cashFlowAllocationList || []
            return list
              .map((item) => {
                const name =
                  item.cashFlowItemName ||
                  item.cash_flow_item_name ||
                  item.cashFlowItemCode ||
                  item.cash_flow_item_code
                return `${name}: ${this.showPrice(item.amount, record.currency)}`
              })
              .join('; ')
          },
        },
      ]
    },
    scrollHeight() {
      return window.innerHeight - 520
    },
    previewColumns() {
      const isBalanceSheet = this.previewForm.templateType === 'BALANCE_SHEET'
      const amountColumns = isBalanceSheet
        ? [
            {
              title: this.$t('期末余额'),
              dataIndex: 'currentPeriodAmount',
              scopedSlots: { customRender: 'currentPeriodAmount' },
            },
            {
              title: this.$t('期初余额'),
              dataIndex: 'lastPeriodAmount',
              scopedSlots: { customRender: 'lastPeriodAmount' },
            },
          ]
        : [
            {
              title: this.$t('本期金额'),
              dataIndex: 'currentPeriodAmount',
              scopedSlots: { customRender: 'currentPeriodAmount' },
            },
            {
              title: this.$t('上期金额'),
              dataIndex: 'lastPeriodAmount',
              scopedSlots: { customRender: 'lastPeriodAmount' },
            },
            {
              title: this.$t('本年累计金额'),
              dataIndex: 'currentYearAmount',
              scopedSlots: { customRender: 'currentYearAmount' },
            },
          ]
      return [
        {
          title: this.$t('项目名称'),
          dataIndex: 'content',
          scopedSlots: { customRender: 'content' },
          width: '50%',
        },
        ...amountColumns,
      ]
    },
    previewAmountStyle() {
      return {
        border: 'none',
        textAlign: 'right',
      }
    },
  },
  methods: {
    ...mapMutations(['addPane']),
    reset() {
      Object.assign(this.$data, this.$options.data())
      this.setColumns()
      this.queryList()
    },
    setColumns() {
      this.formData.businessUnitCode = this.$store.state.defaultBu?.code
      this.formData.businessUnitName = this.$store.state.defaultBu?.name
      this.columns = [
        {
          title: this.$t('凭证单据号'),
          dataIndex: 'voucher_sn',
          scopedSlots: {
            customRender: 'voucherSn',
          },
          width: 200,
        },
        {
          title: this.$t('账簿'),
          dataIndex: 'account_set_name',
          width: 120,
        },
        {
          title: this.$t('结算组织'),
          dataIndex: 'business_unit_name',
          width: 120,
        },
        {
          title: this.$t('凭证状态'),
          dataIndex: 'status',
          customRender: (text) => this.journalVoucherStatusMapping[text],
        },
        {
          title: this.$t('期间'),
          dataIndex: 'accounting_period_name',
          width: 120,
        },
        {
          title: this.$t('来源单据'),
          dataIndex: 'source_doc_type',
          customRender: (text) => this.documentTypeMapping[text],
        },
        {
          title: this.$t('来源单据单号'),
          dataIndex: 'source_doc_sn',
          scopedSlots: {
            customRender: 'source_doc_sn',
          },
          width: 200,
        },
        {
          title: this.$t('凭证号'),
          dataIndex: 'voucher_no',
        },
        {
          title: this.$t('凭证字'),
          dataIndex: 'voucher_type',
          customRender: (text) => this.journalVoucherTypeMapping[text],
        },
        {
          title: this.$t('业务日期'),
          dataIndex: 'biz_date',
          customRender: (text) => text?.split(' ')?.[0],
          width: 120,
        },
        {
          title: this.$t('记账日期'),
          dataIndex: 'accounting_date',
          customRender: (text) => text?.split(' ')?.[0],
          width: 120,
        },
        {
          title: this.$t('借方合计'),
          dataIndex: 'debit_amount',
        },
        {
          title: this.$t('贷方合计'),
          dataIndex: 'credit_amount',
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
        },
      ]
    },
    showPrice(num, currency) {
      if (num !== undefined) {
        return this.$currencySymbol(num, currency)
      }
    },
    chooseBizTime(date) {
      this.formData.bizTimeStart = date.start_time
      this.formData.bizTimeEnd = date.end_time
    },
    chooseAccountingDate(date) {
      this.formData.accountingDateStart = date.start_time
      this.formData.accountingDateEnd = date.end_time
    },
    paginate(data) {
      this.pageNo = data.pageNo
      this.pageSize = data.pageSize
      this.queryList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    setSearchStatus(status) {
      this.formData.status = status
      this.pageNo = 1
      this.selectedRowKeys = []
      this.$nextTick(() => {
        this.queryList()
      })
    },
    queryList(pageNo = 0) {
      if (!this.formData.businessUnitCode) return
      if (pageNo) {
        this.pageNo = pageNo
      }
      this.loading = true
      http({
        url: api.getVoucherList,
        data: {
          page_no: this.pageNo,
          page_size: this.pageSize,
          ...this.formData,
        },
        success: (res) => {
          let list = res.result.list
          this.tableData = list.map((item) => {
            let debit_amount = 0,
              credit_amount = 0,
              currency
            item.detail_list.forEach((elem) => {
              currency = elem.currency
              if (elem.direction === 'CREDIT') {
                elem.credit_amount = elem.amount
              } else {
                elem.debit_amount = elem.amount
              }
              credit_amount = add(credit_amount, elem.credit_amount || 0)
              debit_amount = add(debit_amount, elem.debit_amount || 0)
            })
            item.debit_amount = this.showPrice(debit_amount, currency) || 0
            item.credit_amount = this.showPrice(credit_amount, currency) || 0

            item.detail_list.push({
              type: 'summary',
              debit_amount: item.debit_amount || '0',
              credit_amount: item.credit_amount || '0',
            })
            return item
          })
          this.total = res.result.total
          this.loading = false
        },
        fail: (err) => {
          this.$message.error(err.msg || this.$t('出错了'))
          this.loading = false
        },
      })
    },
    createHandle() {
      this.$router.push({
        path: '/voucherManage/voucherDetail',
      })
    },
    openImportModal() {
      this.importVisible = true
      this.fileList = []
      this.importLoading = false
    },
    handleImportCancel() {
      this.importVisible = false
      this.fileList = []
      this.importLoading = false
    },
    handleUploadChange({ fileList }) {
      this.fileList = fileList
    },
    async handleChange({ file, onSuccess, onError }) {
      try {
        if (!file) return
        const rawFile = file.originFileObj || file
        const fileName = rawFile.name || ''
        const isExcelFile = /\.(xls|xlsx)$/i.test(fileName)
        if (!isExcelFile) {
          this.$message.error('请上传 Excel（.xls/.xlsx）文件')
          onError && onError(new Error('INVALID_EXCEL_FILE'))
          return
        }

        this.importLoading = true

        const formData = new FormData()
        formData.append('file', rawFile)
        formData.append('merchantCode', localStorage.getItem('merchantCode'))
        const cpid =
          this.$store.state.userSession?.currentBu?.id ||
          this.$store.state.userSession?.buList?.[0]?.id
        const language = localStorage.getItem('lang') || 'zh'
        const languageMapping = {
          zh: 'zh_CN',
          en: 'en_US',
          th: 'th_TH',
        }
        const requestId = `rqname${Date.now()}`
        let importUrl = `${api.voucherImport}?requestId=${requestId}&language=${languageMapping[language]}`
        if (cpid) {
          importUrl += `&cpid=${cpid}`
        }

        const res = await fetch(importUrl, {
          method: 'POST',
          body: formData,
          credentials: 'include',
          headers: {
            Authorization: getCookie('d_session_id'),
          },
        })
        const result = await res.json()
        if (![200, 1000000].includes(+result.code)) {
          throw new Error(result.subMsg || result.msg || result.message || this.$t('上传失败'))
        }

        this.$message.success(this.$t('导入成功'))
        this.importVisible = false
        this.fileList = []
        this.importLoading = false
        this.queryList(1)

        onSuccess && onSuccess(result)
      } catch (err) {
        this.importLoading = false
        this.$message.error(err?.msg || err?.message || this.$t('上传失败'))
        onError && onError(err)
      }
    },
    openReportPreview() {
      if (!this.formData.businessUnitCode) {
        return this.$message.warning(this.$t('请先选择结算组织'))
      }
      this.reportPreviewVisible = true
      this.showPreviewTable = false
      this.previewTableData = []
      this.previewForm = {
        templateCode: undefined,
        templateName: undefined,
        templateType: undefined,
        accountingPeriodList: [],
      }
      this.$nextTick(() => {
        if (this.$refs.reportTemplateSelect) {
          this.$refs.reportTemplateSelect.getList()
        }
        if (this.formData.businessUnitCode && this.$refs.accountingPeriodRange) {
          this.$refs.accountingPeriodRange.getCurrentAccountingPeriod()
        }
      })
    },
    handleReportPreviewCancel() {
      this.reportPreviewVisible = false
      this.showPreviewTable = false
      this.previewTableData = []
    },
    changeReportTemplate(item) {
      this.previewForm.templateType = item?.type
    },
    previewReport() {
      const { businessUnitCode } = this.formData
      const { templateCode, templateType, accountingPeriodList } = this.previewForm
      if (!businessUnitCode) return this.$message.warning(this.$t('请先选择结算组织'))
      if (!templateCode) return this.$message.warning(this.$t('请选择报表模板'))
      if (!accountingPeriodList || accountingPeriodList.length === 0) {
        return this.$message.warning(this.$t('请选择会计期间'))
      }

      this.previewLoading = true
      http({
        url: api.getFinancialStatementPreview,
        data: {
          ...this.formData,
          type: templateType,
          templateCode,
          accountingPeriodList,
        },
        success: (res) => {
          let result = res.result?.list || res.result || []
          this.previewTableData = convertKeysToCamelCase(result)
          this.showPreviewTable = true
        },
        fail: (err) => {
          this.$message.error(err.msg || this.$t('出错了'))
        },
      }).finally(() => {
        this.previewLoading = false
      })
    },
    viewDetail(record) {
      this.addPane({
        view: 'voucherDetail/' + record.voucher_sn,
        name: 'detailSn',
        query: {
          id: record.id,
          sn: record.voucher_sn,
        },
        route: `/voucherManage/voucherDetail?id=${record.id}&sn=${record.voucher_sn}`,
      })
    },
    viewSourceDetail(record, index) {
      let source_doc_sn_list = record.source_doc_sn.split(','),
        source_doc_id_list = record.source_doc_id.split(',')
      jumpSoucePage(source_doc_sn_list[index], source_doc_id_list[index])
    },
    changeColumns(list) {
      this.columns = list
    },
  },
}
</script>

<style scoped>
.no-padding-table :deep(td),
.no-padding-table :deep(th) {
  padding: 4px !important;
}

.no-padding-table :deep(th) {
  text-align: center;
}
</style>
